import React, { useEffect, useState } from 'react';
import { Button } from '../../components/catalyst/button';
import { useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions, realtimeDb } from '../../config/firebaseConfig';
import { createCheckoutSession } from '../../util/stripeClient';
import Snackbar from '../../components/ExistingSessionSnackbarComponent';
import { getDatabase, ref, onValue } from "firebase/database";

export default function OnBoardPage() {
  const navigate = useNavigate();
  const [isReportProcessing, setIsReportProcessing] = useState(false);
  const [isReportsFetching, setIsReportsFetching] = useState(false);
  const [isReportsBuying, setIsReportsBuying] = useState(false);
  const callTemplateManager = httpsCallable(functions, "templateManager");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackBarType, setSnackBarType] = useState<"success" | "error" | null>();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [progress, setProgress] = useState(0);
  const [reportId, setReportId] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId) return;
  
    const progressRef = ref(realtimeDb, `runs/${reportId}`);
  
    const unsubscribe = onValue(progressRef, (snapshot) => {
      const data = snapshot.val();
  
      console.log("Realtime Progress:", data);
  
      if (!data) return;
  
      let calculatedProgress = 0;
  
      const statusLog = data.statusLog || {};
  
      if (statusLog.workflowStarted) {
        calculatedProgress = 20;
      }
  
      if (statusLog.fetchTemplate) {
        calculatedProgress = 40;
      }
  
      if (statusLog.executionTriggered) {
        calculatedProgress = 60;
      }
  
      if (
        statusLog.executionResult &&
        statusLog.executionResult.status === "success"
      ) {
        calculatedProgress = 80;
      }
  
      if (data.finishedAt) {
        calculatedProgress = 100;
        setIsReportProcessing(false);
      }
  
      setProgress(calculatedProgress);
    });
  
    return () => unsubscribe();
  }, [reportId]);


  async function handleBuyBase() {
    setIsReportsBuying(true);
  
    const performFn = httpsCallable(functions, "performReportReview");
  
    try {
      const res: any = await performFn({
        action: "buyBaseReport",
        reportId: "0",
      });
  
      const result = res.data;  // <--- from backend
  
      console.log("Base report buy result:", result);
  
      
  
      // ⭐ PAID REPORT FLOW — CREATE STRIPE SESSION
      const sessionData = await createCheckoutSession(
        result.data.itemTitle,
        result.data.amount,
        result.data.email,
        result.data.templateId,
        result.data.userId,
        result.data.userName
      );
  
      if (sessionData.url) {
        window.location.href = sessionData.url;
      }
      // ⭐ FREE REPORT FLOW
      if (sessionData.free) {
        setSnackbarMessage("Your base report is being processed.");
        setSnackBarType("success");
        setShowSnackbar(true);
  
        await loadPublishedTemplates();
        setIsReportsBuying(false);
        return;
      }
      setIsReportProcessing(true)
    } catch (err) {
      console.error("Buy Base Report Error:", err);
      alert("Something went wrong. Please try again.");
    }
  
    setIsReportsBuying(false);
  }
  
  useEffect(() => {
    loadPublishedTemplates();
  }, []);

  async function loadPublishedTemplates() {
    setIsReportsFetching(true);
  
    try {
      const res = await callTemplateManager({
        action: "fetchPublished",
      });
  
      const data = res.data as {
        userReports: any[];
      };
  
      console.log("✅ User Rep:", data.userReports);
  
      console.log(data.userReports.length)
      if (data.userReports.length > 0) {
        const latestReport = data.userReports[0];
  
        console.log("sadasdasd")
        console.log("reportId", latestReport.workflowRunId)
        setReportId(latestReport.workflowRunId);
        setIsReportProcessing(true);
      }
  
      setIsReportsFetching(false);
    } catch (err: any) {
      setIsReportsFetching(false);
  
      console.error(
        "❌ Failed to fetch published templates:",
        err.message
      );
    }
  }
  
  return (
    <div className="min-h-screen w-full bg-[#1C1C1C] text-white overflow-y-auto">

<style>
{`
  .loading-dots {
    display: inline-block;
    width: 20px; /* fixed space for dots */
    text-align: left;
  }

  .loading-dots::after {
    content: ".";
    animation: dots 1s steps(3, end) infinite;
  }

  @keyframes dots {
    0% { content: "."; }
    33% { content: ".."; }
    66% { content: "..."; }
    100% { content: "."; }
  }
`}
</style>


      {/* Hero Section */}
      <section className="relative w-full h-[100vh] flex flex-col items-center justify-center text-center px-6">
        <img
          src="/Hero Background.svg"
          alt="Hero Gradient"
          className="absolute inset-0 w-full h-full object-cover opacity-80"
        />
        <div className="relative z-10 max-w-2xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Quantum Identification Decoder
          </h1>
          <p className="text-lg md:text-xl text-gray-300 mb-8">
            Where frequency meets identity.
          </p>
          <p className="text-base text-gray-400 mb-8">
            Your name is not random. It is a resonance field waiting to be remembered. We believe your name is more than a label—it’s a frequency. Every letter carries information. Every vibration holds insight. Through quantum science and symbolic mapping, we decode the energy hidden in your name to help align you with your most authentic self.
          </p>
          {isReportProcessing ? (
  <div className="w-full max-w-md mx-auto mt-4 text-dark-text">
  <p className="mb-3 text-center">
    Free Core Analysis Report being processed
  </p>

  <div className="h-3 w-full overflow-hidden rounded-full bg-gray-700">
    <div
      className="h-full rounded-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all duration-300"
      style={{ width: `${progress}%` }}
    />
  </div>

  <p className="mt-2 text-center text-sm text-gray-400">
    {progress}%
  </p>
</div>
) :(
          <Button
  disabled={  isReportsFetching || isReportsBuying}
  onClick={handleBuyBase}
  className={`
    bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 
    text-white px-6 py-3 rounded-lg font-medium shadow-lg flex items-center
    ${isReportProcessing ? "opacity-60 pointer-events-none cursor-not-allowed" : ""}
    ${isReportsBuying ? "opacity-60 pointer-events-none cursor-not-allowed" : ""}
  `}
>
  {isReportsBuying ? "Purchasing Free Core Analysis Report" : "Generate your Free Core Analysis Report" }

  {( isReportsBuying) && <span className="ml-2 loading-dots"></span>}
</Button>
          )}

          {/* <p className="text-sm text-gray-500 mt-3">
            It will be ready within two working days — and we’ll notify you.
          </p> */}
        </div>
      </section>

      {/* Core Analysis Section */}
      {!isReportProcessing && (
      <section className="w-full py-20 bg-[#121212] px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            The Core Analysis Report is the foundation.
          </h2>
          <p className="text-gray-400 mb-12 leading-relaxed">
            We build upon the core analysis, and offer a wide range of reports, each of which reveals a deeper layer of your energetic identity.
            Whether you purchase details about your name’s resonance, frequency, or spiritual function — or wish to deepen your understanding of your relationships, this expanded mapping helps you navigate your journey. Once your core analysis report is ready, it will empower you to explore these additional reports, including the following.
          </p>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
            <div className="bg-[#1E1E1E] border border-gray-700 p-6 rounded-2xl text-left">
              <h3 className="text-xl font-semibold mb-2">Karmic Energy</h3>
              <p className="text-gray-400">Past-life echoes, soul contracts, and karmic imprints.</p>
            </div>

            <div className="bg-[#1E1E1E] border border-gray-700 p-6 rounded-2xl text-left">
              <h3 className="text-xl font-semibold mb-2">Relationship Resonance</h3>
              <p className="text-gray-400">Compatibility by frequency — offers a look at how energies align.</p>
            </div>

            <div className="bg-[#1E1E1E] border border-gray-700 p-6 rounded-2xl text-left">
              <h3 className="text-xl font-semibold mb-2">Synchronicity Tracker</h3>
              <p className="text-gray-400">Tracking repeating patterns, numbers, and alignments.</p>
            </div>

            <div className="bg-[#1E1E1E] border border-gray-700 p-6 rounded-2xl text-left">
              <h3 className="text-xl font-semibold mb-2">Atlanteic Blueprint</h3>
              <p className="text-gray-400">Soul origins, divine mission, and essence memory.</p>
            </div>
          </div>

          {/* Relationship Reports CTA */}
          <div className="relative h-64 p-8 flex flex-col justify-center">
            {/* Background layer (faded image) */}
            <div
              className="absolute inset-0 bg-no-repeat bg-cover bg-bottom brightness-75"
              style={{ backgroundImage: "url('/bg-relation.png')" }}
            ></div>

            {/* Optional dark overlay */}
            <div className="absolute inset-0 bg-black/30"></div>

            {/* Content layer (not faded) */}
            <div className="relative z-10">
              <h3 className="text-2xl font-semibold mb-4 text-white">
                Relationship Reports
              </h3>

              <p className="text-white mb-6">
              If you wish to understand your compatibility & synergy with others, then please <span className='text-brand-500 cursor-pointer underline' onClick={() => navigate('/user/profile')}>create their profile</span> — this could be a significant other, family members, or friends.
              </p>
            </div>
          </div>


        </div>
      </section>
      )}

      {/* ⚠️ Snackbar */}
      {showSnackbar && (
        <Snackbar
          message={snackbarMessage}
          type={snackBarType}
        />
      )}

    </div>
  );
}
